import React, {useEffect, useLayoutEffect, useRef} from 'react';

export default function ArticleEmbed({ key, part }) {
	if (!part.value) return;

	const markup = part.value;

	const elRef = useRef();

	useLayoutEffect(() => {
		if (part.runAsScript) {
			const range = document.createRange();
			range.selectNode(elRef.current);
			const documentFragment = range.createContextualFragment(markup);

			// Inject the markup, triggering a re-run!
			elRef.current.innerHTML = '';
			elRef.current.append(documentFragment);
		}
	}, []);

	return (
		<div
			ref={elRef}
			dangerouslySetInnerHTML={{ __html: markup }}>
	</div>
	);
}

